import { Base64 } from 'js-base64';
import Login from './views/Login.vue';
import NotFound from './views/NotFound.vue';
import Router from 'vue-router';
import Vue from 'vue';
import storage from './uitls/cacheUtil';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: 'default',
      redirect: '/404',
    },
    {
      path: '',
      name: 'Empty',
      component: Login,
      meta: {
        title: '',
        auth: 'none',
        hideTitle: true,
      },
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: '',
        auth: 'none',
        hideTitle: true,
      },
    },
    // companyIdStr,处理后的合作单位id(处理规则：base64(`_${companyId}`))
    {
      path: '/:companyIdStr?/login',
      name: 'Login',
      component: Login,
      props: true,
      meta: {
        title: '登录',
        auth: 'none',
        hideTitle: true,
      },
    },
    {
      path: '/login/success',
      name: 'LoginSuccess',
      component: () => import(/* webpackChunkName: "LoginSuccess" */ './views/LoginSuccess.vue'),
      meta: {
        title: '登录成功',
      },
    },
    {
      path: '/home',
      name: 'Home',
      props: true,
      component: () => import(/* webpackChunkName: "Home" */ './views/home/Home.vue'),
      meta: {
        title: '首页',
        hideTitle: true,
      },
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: () => import(/* webpackChunkName: "UserList" */ './views/user/UserList.vue'),
      meta: {
        title: '用户列表',
      },
    },
    {
      path: '/user/home',
      name: 'UserHome',
      component: () => import(/* webpackChunkName: "UserHome" */ './views/user/UserHome.vue'),
      meta: {
        title: '添加用户',
      },
    },
    {
      path: '/user/edit/:userType/:id?', // userType: bjs--报价商、hzdw--合作单位
      name: 'UserEdit',
      props: true,
      component: () => import(/* webpackChunkName: "UserList" */ './views/user/UserEdit.vue'),
      meta: {
        title: '编辑用户',
      },
    },
    {
      path: '/user/store/list/:webStoreId',
      name: 'StoreList',
      component: () => import(/* webpackChunkName: "StoreList" */ './views/user/StoreList.vue'),
      meta: {
        title: '选择小程序门店',
      },
    },
    {
      path: '/user/sync/rule/:id?',
      name: 'UserSyncRule',
      props: true,
      component: () => import(/* webpackChunkName: "UserSyncRule" */ './views/user/UserSyncRule.vue'),
      meta: {
        title: '同步规则设置',
      },
    },
    {
      path: '/quotation/edit',
      name: 'QuotationEdit',
      component: () => import(/* webpackChunkName: "QuotationEdit" */ './views/quotation/QuotationEdit.vue'),
      meta: {
        title: '报价发布页',
        hideTitle: true,
      },
    },
    {
      path: '/quotation/edit/success/:quoteType?',
      name: 'QuotationEditSuccess',
      props: true,
      component: () => import(/* webpackChunkName: "QuotationEditSuccess" */ './views/quotation/QuotationEditSuccess.vue'),
      meta: {
        title: '报价发布成功',
        hideTitle: true,
      },
    },
    {
      path: '/quotation/poster/:quoteType?',
      name: 'QuotationPoster',
      props: true,
      component: () => import(/* webpackChunkName: "QuotationPoster" */ './views/quotation/QuotationPoster.vue'),
      meta: {
        title: '报价单生成',
        hideTitle: true,
      },
    },
    {
      path: '/tool/quotation/poster/:tpl?',
      name: 'QuotationPosterTool',
      props: true,
      component: () => import(/* webpackChunkName: "QuotationPoster" */ './views/quotation/QuotationPoster.vue'),
      meta: {
        title: '报价单生成',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/quotation/list/:quoteTypeProp/:queryDateProp', // quoteType 1-龙虾 2-螃蟹
      name: 'QuotationList',
      component: () => import(/* webpackChunkName: "QuotationList" */ './views/mp/mp.vue'),
      props: true,
      meta: {
        title: '报价信息',
        auth: 'none',
        hideTitle: true,
      },
    },
    // for 微信公众号--无个人二维码
    {
      path: '/wechat/quotation/list/:quoteTypeProp/:queryDateProp', // quoteType 1-龙虾 2-螃蟹
      name: 'WechatQuotationList',
      component: () => import(/* webpackChunkName: "QuotationList" */ './views/mp/mp.vue'),
      props: true,
      meta: {
        title: '报价信息',
        auth: 'none',
        hideTitle: true,
        hideQrcode: true,
      },
    },
    // for 合作单位定制链接  companyIdStr,处理后的合作单位id、报价类型(处理规则：base64(`${companyId}_${quoteType}`))
    // quoteType 1-龙虾 2-螃蟹
    {
      path: '/:companyIdStr/baojia/:queryDateProp',
      name: 'CompanyQuotationList',
      component: () => import(/* webpackChunkName: "QuotationList" */ './views/quotation/QuotationList.vue'),
      props: true,
      meta: {
        title: '报价信息',
        auth: 'none',
        hideTitle: true,
      },
    },
    // 报价单小工具
    {
      path: '/quotation/template',
      name: 'QuotationTemplate',
      component: () => import(/* webpackChunkName: "QuotationTemplate" */ './views/quotation/QuotationTemplate.vue'),
      props: true,
      meta: {
        title: '水产销售宣传工具',
        auth: 'none',
        hideTitle: true,
      },
    },
    {
      path: '/quotation/posteredit/:tpl?',
      name: 'QuotationPosterEdit',
      component: () => import(/* webpackChunkName: "QuotationPosterEdit" */ './views/quotation/QuotationPosterEdit.vue'),
      props: true,
      meta: {
        title: '报价单信息',
        auth: 'none',
        hideTitle: true,
      },
    },
    {
      path: '/notice/info',
      name: 'NoticeInfo',
      component: () => import(/* webpackChunkName: "NoticeList" */ './views/notice/NoticeList.vue'),
      meta: {
        title: '公告列表',
      },
    },
    {
      path: '/notice/edit/:id?',
      name: 'NoticeEdit',
      props: true,
      component: () => import(/* webpackChunkName: "NoticeEdit" */ './views/notice/NoticeEdit.vue'),
      meta: {
        title: '公告新增/编辑',
      },
    },
    {
      path: '/data/info',
      name: 'DataInfo',
      component: () => import(/* webpackChunkName: "DataInfo" */ './views/DataInfo.vue'),
      meta: {
        title: '数据统计',
      },
    },
    {
      path: '/AD/info/list',
      name: 'ADInfoList',
      component: () => import(/* webpackChunkName: "ADInfoList" */ './views/ad/ADInfoList.vue'),
      meta: {
        title: '广告',
      },
    },
    {
      path: '/AD/info/edit/:id?',
      name: 'ADInfoEdit',
      props: true,
      component: () => import(/* webpackChunkName: "ADInfoEdit" */ './views/ad/ADInfoEdit.vue'),
      meta: {
        title: '广告',
      },
    },
    {
      path: '/btn/info',
      name: 'BtnInfo',
      component: () => import(/* webpackChunkName: "BtnInfo" */ './views/BtnInfo.vue'),
      meta: {
        title: '按钮',
      },
    },
    {
      path: '/inventory/shrimp/info',
      name: 'InventoryShrimpInfo',
      component: () => import(/* webpackChunkName: "InventoryShrimpInfo" */ './views/InventoryShrimpInfo.vue'),
      meta: {
        title: '库虾内容',
      },
    },
    {
      path: '/stock/info/home',
      name: 'StockInfoHome',
      component: () => import(/* webpackChunkName: "StockInfoList" */ './views/stock/StockInfoHome.vue'),
      meta: {
        title: '库虾首页',
      },
    },
    {
      path: '/stock/list/:queryDateProp?',
      name: 'StockInfoList',
      props: true,
      component: () => import(/* webpackChunkName: "StockInfoList" */ './views/stock/StockInfoList.vue'),
      meta: {
        title: '库虾价格列表',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/stock/info/edit',
      name: 'StockInfoEdit',
      component: () => import(/* webpackChunkName: "StockInfoEdit" */ './views/stock/StockInfoEdit.vue'),
      meta: {
        title: '库虾价格编辑',
      },
    },
    {
      path: '/stock/company/list',
      name: 'StockCompany',
      component: () => import(/* webpackChunkName: "StockCompany" */ './views/stock/StockCompany.vue'),
      meta: {
        title: '库虾公司',
      },
    },
    {
      path: '/stock/category/list',
      name: 'StockCategory',
      component: () => import(/* webpackChunkName: "StockCategory" */ './views/stock/StockCategory.vue'),
      meta: {
        title: '库虾行话',
      },
    },
    {
      path: '/black/list/home',
      name: 'BlackListHome',
      component: () => import(/* webpackChunkName: "BlackListHome" */ './views/black-list/BlackListHome.vue'),
      meta: {
        title: '黑名单',
        hideTitle: true,
      },
    },
    // {
    //   path: '/black/list/query',
    //   name: 'BlackListQuery',
    //   component: () => import(/* webpackChunkName: "BlackListDetail" */ './views/black-list/BlackListDetail.vue'),
    //   meta: {
    //     title: '黑名单查询',
    //     // hideTitle: true,
    //   },
    // },
    {
      path: '/black/list/query',
      name: 'BlackListQuery',
      component: () => import(/* webpackChunkName: "BlackListSearch" */ './views/black-list/BlackListSearch.vue'),
      meta: {
        title: '黑名单查询',
        // hideTitle: true,
      },
    },
    {
      path: '/black/list/result',
      name: 'BlackListResult',
      component: () => import(/* webpackChunkName: "BlackListResult" */ './views/black-list/BlackListResult.vue'),
      meta: {
        title: '黑名单查询结果',
        hideTitle: true,
      },
    },
    {
      path: '/black/list/detail/:id?',
      name: 'BlackListDetail',
      props: true,
      component: () => import(/* webpackChunkName: "BlackListReport" */ './views/black-list/BlackListReport.vue'),
      meta: {
        title: '黑名单明细',
        hideTitle: true,
      },
    },
    // {
    //   path: '/black/list/edit/:id?',
    //   name: 'BlackListEdit',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "BlackListDetail" */ './views/black-list/BlackListDetail.vue'),
    //   meta: {
    //     title: '黑名单明细',
    //     role: 'admin',
    //   },
    // },
    {
      path: '/black/list/edit/:id?',
      name: 'BlackListEdit',
      props: true,
      component: () => import(/* webpackChunkName: "BlackListReport" */ './views/black-list/BlackListReport.vue'),
      meta: {
        title: '黑名单新增/编辑',
        role: 'admin',
      },
    },
    {
      path: '/query/price/home',
      name: 'QueryPrice',
      props: true,
      component: () => import(/* webpackChunkName: "QueryPrice" */ './views/mp/mp.vue'),
      meta: {
        title: '水产价格查询工具',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/query/price/result/:pm?',
      name: 'QueryPriceResult',
      props: true,
      component: () => import(/* webpackChunkName: "QueryPriceResult" */ './views/mp/mp.vue'),
      meta: {
        title: '水产价格查询结果',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/download/price/:pm?',
      name: 'QueryPriceDownload',
      props: true,
      component: () => import(/* webpackChunkName: "QueryPriceDownload" */ './views/price/QueryPriceDownload.vue'),
      meta: {
        title: '水产价格导出图片',
        hideTitle: true,
        hideQrcode: true,
        // auth: 'none',
      },
    },
    {
      path: '/wechat/query/price/home',
      name: 'QueryPriceWechat',
      props: true,
      component: () => import(/* webpackChunkName: "QueryPrice" */ './views/price/QueryPrice.vue'),
      meta: {
        title: '水产价格查询工具',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/wechat/query/price/result/:pm?',
      name: 'QueryPriceResultWechat',
      props: true,
      component: () => import(/* webpackChunkName: "QueryPriceResult" */ './views/price/QueryPriceResult.vue'),
      meta: {
        title: '水产价格查询结果',
        hideTitle: true,
        auth: 'none',
        hideQrcode: true,
      },
    },
    {
      path: '/test/price/home',
      name: 'TestPrice',
      props: true,
      component: () => import(/* webpackChunkName: "TestPrice" */ './views/price/TestPrice.vue'),
      meta: {
        title: '水产价格测算工具',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/test/price/result/:pm?',
      name: 'TestPriceResult',
      props: true,
      component: () => import(/* webpackChunkName: "TestPriceResult" */ './views/price/TestPriceResult.vue'),
      meta: {
        title: '水产价格测算结果',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/market/info/home',
      name: 'MarketInfoHome',
      component: () => import(/* webpackChunkName: "MarketInfoHome" */ './views/market/MarketInfoHome.vue'),
      meta: {
        title: '行情首页',
      },
    },
    // { name: '行情类型', path: '/market/type/list' },
    // { name: '行情价格', path: '/market/info/edit' },
    {
      path: '/market/type/list',
      name: 'MarketType',
      component: () => import(/* webpackChunkName: "MarketType" */ './views/market/MarketType.vue'),
      meta: {
        title: '行情类型',
      },
    },
    {
      path: '/market/info/edit',
      name: 'MarketInfoEdit',
      component: () => import(/* webpackChunkName: "MarketInfoEdit" */ './views/market/MarketInfoEdit.vue'),
      meta: {
        title: '行情价格编辑',
      },
    },
    {
      path: '/member/list',
      name: 'MemberList',
      component: () => import(/* webpackChunkName: "MemberList" */ './views/member/MemberList.vue'),
      meta: {
        title: '水产圈子用户管理',
      },
    },
    {
      path: '/saleDemand/list',
      name: 'SaleDemandList',
      component: () => import(/* webpackChunkName: "SaleDemandList" */ './views/sales/SaleDemandList.vue'),
      meta: {
        title: '水产圈子买卖信息管理',
      },
    },
    {
      path: '/article/list',
      name: 'ArticleList',
      component: () => import(/* webpackChunkName: "ArticleList" */ './views/article/ArticleList.vue'),
      meta: {
        title: '文章列表',
      },
    },
    {
      path: '/article/edit/:id?',
      name: 'ArticleEdit',
      component: () => import(/* webpackChunkName: "ArticleEdit" */ './views/article/ArticleEdit.vue'),
      meta: {
        // title: '新增/编辑文章',
      },
    },
    {
      path: '/article/detail/:id?',
      name: 'ArticleDetail',
      component: () => import(/* webpackChunkName: "ArticleDetail" */ './views/article/ArticleDetail.vue'),
      meta: {
        title: '详情',
        hideTitle: true,
      },
    },
    {
      path: '/article/mp/:type/:id?',
      name: 'ArticleViewMp',
      component: () => import(/* webpackChunkName: "ArticleViewMp" */ './views/article/ArticleViewMp.vue'),
      meta: {
        title: '详情',
        hideTitle: true,
        auth: 'none',
      },
    },
    {
      path: '/origin/market/list',
      name: 'OriginMarketList',
      component: () => import(/* webpackChunkName: "originMarketList" */ './views/origin-market/OriginMarketList.vue'),
      meta: {
        title: '批发市场',
      },
    },
    {
      path: '/origin/apply/list',
      name: 'OriginApplyList',
      component: () => import(/* webpackChunkName: "SaleDemandList" */ './views/origin-market/OriginMarketApplyList.vue'),
      meta: {
        title: '水产圈子批发市场审核',
      },
    },
    {
      path: '/store/apply/list',
      name: 'StoreApplyList',
      component: () => import(/* webpackChunkName: "StoreApplyList" */ './views/store/StoreApplyList.vue'),
      meta: {
        title: '水产圈子门店审核',
      },
    },
    {
      path: '/store/complaint/list',
      name: 'StoreComplaintList',
      component: () => import(/* webpackChunkName: "StoreComplaintList" */ './views/store/StoreComplaintList.vue'),
      meta: {
        title: '水产圈子门店投诉列表',
      },
    },
    {
      path: '/store/apply/edit/:storeId',
      name: 'StoreApplyEdit',
      props: true,
      component: () => import(/* webpackChunkName: "StoreEdit" */ './views/store/StoreEdit.vue'),
      meta: {
        title: '水产圈子门店明细',
      },
    },
    {
      path: '/origin-enterprise/apply/list',
      name: 'OriginEnterpriseApplyList',
      component: () => import(/* webpackChunkName: "originEnterpriseApplyList" */ './views/origin-enterprise/OriginEnterpriseApplyList.vue'),
      meta: {
        title: '水产圈子源头企业审核',
      },
    },
    {
      path: '/origin-enterprise/complaint/list',
      name: 'OriginEnterpriseComplaintList',
      component: () => import(/* webpackChunkName: "OriginEnterpriseComplaintList" */ './views/origin-enterprise/OriginEnterpriseComplaintList.vue'),
      meta: {
        title: '水产圈子源头企业投诉列表',
      },
    },
    {
      path: '/origin-enterprise/apply/edit/:originEnterpriseId',
      name: 'OriginEnterpriseApplyEdit',
      props: true,
      component: () => import(/* webpackChunkName: "OriginEnterpriseEdit" */ './views/origin-enterprise/OriginEnterpriseEdit.vue'),
      meta: {
        title: '水产圈子源头企业明细',
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  // console.log(to);

  const type = storage.local.get('type');
  const token = storage.local.get('token');
  if (to.name === 'Login' || to.name === 'Empty') {
    if (token) {
      if (type === 4) {
        next('/login/success');
      } else {
        next('/home');
      }
    } else {
      next();
    }
  } else if (to.meta.auth !== 'none' && !token) {
    const companyId = storage.local.get('C_ID') || '';
    const link = `${companyId ? `/${Base64.encodeURL(`_${companyId || ''}`)}` : ''}`;
    next(`${link}/login`);
  } else {
    next();
  }
});
export default router;
